import clsx from "clsx";
import type { ButtonHTMLAttributes } from "react";

type Variant = "primary" | "secondary" | "ghost" | "destructive";

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  loading?: boolean;
}

export const Button = ({ variant = "primary", loading, className, children, ...props }: Props): JSX.Element => {
  return (
    <button
      {...props}
      className={clsx(
        "btn",
        {
          "btn-primary": variant === "primary",
          "btn-secondary": variant === "secondary",
          "btn-ghost": variant === "ghost",
          "bg-[var(--status-blocker)] text-white": variant === "destructive"
        },
        className
      )}
      disabled={props.disabled || loading}
    >
      {loading ? "Loading..." : children}
    </button>
  );
};
